
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

export interface SolutionProps {
  id: string;
  title: string;
  description: string;
  image: string;
  link: string;
  benefits: string[];
}

const SolutionCard = ({ solution }: { solution: SolutionProps }) => {
  return (
    <Card className="premium-card glow-on-hover overflow-hidden">
      <div className="aspect-video bg-forti-fi-lavender/20 overflow-hidden">
        <img 
          src={solution.image} 
          alt={solution.title} 
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
          loading="lazy"
          onError={(e) => {
            // Fallback to a placeholder if image fails to load
            e.currentTarget.src = '/placeholder.svg';
            // Add a console log to help debug
            console.log(`Failed to load image: ${solution.image}`);
          }}
        />
      </div>
      <CardContent className="p-8">
        <h3 className="text-xl font-serif text-forti-fi mb-4">
          <span className="highlight-underline">{solution.title}</span>
        </h3>
        <p className="text-forti-fi-charcoal mb-6 text-base">
          {solution.description}
        </p>
        
        <div className="mt-6 mb-6 space-y-5">
          <h4 className="font-medium text-forti-fi mb-3">Key Benefits</h4>
          <ul className="space-y-3">
            {solution.benefits.map((benefit, idx) => (
              <li key={idx} className="flex items-start">
                <CheckCircle2 className="text-forti-fi mr-2 h-4 w-4 shrink-0 mt-1" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        </div>
        
        <Button asChild variant="outline" className="mt-6 hover-lift group">
          <Link to={solution.link}>
            Learn More <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};

export default SolutionCard;